<script setup>
import axios from 'axios'
import {ref} from "vue";
import {useRoute} from "vue-router";
import {NLayout, NLayoutContent, NLayoutFooter, NFlex, NImage} from "naive-ui";

let privacyText = ref('');
const route = useRoute();

console.log(route.params.app)

axios.get('../' + route.params.app + '/privacy.txt')
    .then(res => {
      console.log(res)
      privacyText.value = res.data;
    })

function toBeian() {
  window.open("https://beian.miit.gov.cn/", '_blank')
}

function toPolice() {
  window.open("https://beian.mps.gov.cn/#/query/webSearch", '_blank')
}
</script>

<template>
  <n-layout class="main-layout" :native-scrollbar="false">
    <n-layout-content class="content" :native-scrollbar="false">
      <div class="privacy-container animate-up">
        <div class="page-title">隐私政策</div>
        <div class="privacy-content">
          {{ privacyText }}
        </div>
      </div>
    </n-layout-content>

    <n-layout-footer class="footer">
      <n-flex vertical align="center" :size="12">
        <n-flex align="center" :size="24" class="footer-info">
          <div>地址：深圳市福田区沙头街道天安社区泰然四路泰然科技园210栋七层7C343</div>
          <div>电话：+86 18128843153</div>
        </n-flex>
        <n-flex align="center" :size="24" class="footer-links">
          <n-flex align="center" @click="toPolice" class="link-item">
            <n-image width="16" height="16" src="../home_police.webp" preview-disabled/>
            <div>粤公网安备44030002006068号</div>
          </n-flex>
          <div @click="toBeian" class="link-item">粤ICP备2024309628号</div>
        </n-flex>
      </n-flex>
    </n-layout-footer>
  </n-layout>
</template>

<style scoped>
.main-layout {
  background: transparent;
  min-height: 100vh;
}

.header {
  background: rgba(16, 16, 20, 0.8);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  height: 64px;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid var(--glass-border);
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  padding: 0 24px;
}

.logo-text {
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(90deg, #fff, #ccc);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.content {
  background: transparent;
  padding: 40px 24px;
}

.privacy-container {
  max-width: 900px;
  margin: 0 auto;
  background: var(--glass-bg);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid var(--glass-border);
  border-radius: 24px;
  padding: 48px;
  box-shadow: var(--glass-shadow);
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 40px;
  color: #fff;
  position: relative;
  padding-bottom: 16px;
}

.page-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #63e2b7, #a064ff);
  border-radius: 2px;
}

.privacy-content {
  white-space: pre-line;
  font-size: 16px;
  line-height: 1.8;
  color: var(--text-color);
  text-align: justify;
  word-break: break-all;
  overflow-wrap: break-word;
}

.footer {
  background: rgba(0, 0, 0, 0.3);
  padding: 40px 24px;
  margin-top: 60px;
  border-top: 1px solid var(--glass-border);
}

.footer-info, .footer-links {
  color: var(--text-secondary);
  font-size: 14px;
}

.link-item {
  cursor: pointer;
  transition: color 0.2s;
}

.link-item:hover {
  color: var(--primary-color);
}

/* Animations */
.animate-up {
  opacity: 0;
  animation: fadeInUp 0.8s ease forwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
